import axios from 'axios';
import store from '../store/store'

export default {
    async execute(method, resource, data) {
        // inject the accessToken for each request
        await store.getters.getPropertyGuid
        await store.getters.getTenantGuid
        await store.getters.getJwtAuthenticationToken
        return axios({
            method,
            data,
            headers: {
                Authorization: store.getters.getJwtAuthenticationToken //the token is a variable which holds the token
            },
            url: "/residents/properties/" + store.getters.getPropertyGuid +
                "/units/devices"+ resource,
        }).then(async req => {
            return req.data
        })
    },
    getDevices(type) {
        if (type == null) {
            return this.execute('get', '')
        } else {
            return this.execute('get', "?type=" + type)
        }
    },
    getById(guid){
        let guidString = '/' + guid
        return this.execute('get', guidString)
    },
    updateDevice(deviceGuid, device){
        let resource = "/" + deviceGuid;
        return this.execute("patch", resource, device);
    },
    async deleteDevice(deviceGuid){
        return this.execute("delete", "/"+deviceGuid);
    }

}
